import { useMemo } from "react"
import { CURVE_TYPE, CurveContent, ICurveDot, IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { IPrimitiveProps } from "../section/Primitive"

/* Protopia Ecosystem component */ 
const Curve = (props: IPrimitiveProps): JSX.Element => { 
    // TODO:: add resize window behovior 
    // const primitive: CurveContent   = ( props.primitive || {} ) as CurveContent
    const primitive: CurveContent   = useComponentData<CurveContent>( (props.primitive || {}) as CurveContent )
    const position: IScreenPosition = primitive.position //usePosition(primitive)  
    
    const path: ICurveDot[]         = primitive.path    || []
    const isClosed: boolean         = !!primitive.isClosed
    const strokeW: number           = primitive.strokeW || 1
    const fill                      = primitive.fill    || "transparent"
    const color                     = primitive.color   || "transparent"    
    const br                        = primitive.borderRadius   || 3    
    const w                 = parseInt((position.width  || "0")?.toString()) || 0
    const h                 = parseInt((position.height || "0")?.toString()) || 0
    const shiftX            = parseInt((position.left   || "0")?.toString()) || 0
    const shiftY            = parseInt((position.top    || "0")?.toString()) || 0
 
    const x         = -shiftX - strokeW 
    const y         = -shiftY - strokeW
    
    const svgWidth  = useMemo(() => w + strokeW * 2, [w, strokeW])
    const svgHeight = useMemo(() => h + strokeW * 2, [h, strokeW])
    
    const getGaps = (): any => { 
        let topDot      =  0 ;
        path.filter((dot: ICurveDot) => !!dot.top ).forEach(dot => {
            topDot = Math.min(topDot, dot.y)
        })
        let leftDot      =  0 ;
        path.filter((dot: ICurveDot) => !!dot.left ).forEach(dot => {
            leftDot = Math.min(leftDot, dot.x)
        })
        let bottomDot      =  0 ;
        path.filter((dot: ICurveDot) => !dot.top ).forEach(dot => {
            bottomDot = Math.max(bottomDot, dot.y)
        })
        let righttDot      =  0 ;
        path.filter((dot: ICurveDot) => !dot.left ).forEach(dot => {
            righttDot = Math.max(righttDot, dot.x)
        })
        return {
            left:   leftDot,
            right:  righttDot,
            top:    topDot,
            bottom: bottomDot
        }
    }
    const gaps = getGaps()
     
    
    const getDot = (dot: ICurveDot) => {
        let left = dot.left 
            ?
            dot.x 
            :
            w + dot.x
        let top = dot.top 
            ?
            dot.y 
            :
            h + dot.y 
        return {left, top}
    }
    const getDotType = (dot: ICurveDot): CURVE_TYPE => {
        return dot.type || CURVE_TYPE.L
    }
    const drawCurve = (): string => { 
        const {left, top} = getDot( path[0] )
        let d: string[] = [ `${CURVE_TYPE.M}${ left - gaps.left + strokeW } ${ top - gaps.top + strokeW }` ]
        path.forEach( (dot: ICurveDot, i) => {
            const { left, top } = getDot(dot)
            d.push( `${ i === 0 ? CURVE_TYPE.M : getDotType(dot) }${ left - gaps.left + strokeW } ${ top - gaps.top + strokeW }` )
        })
        return d.join(",") + (isClosed ? CURVE_TYPE.Z : "")
    }    
    const width  = svgWidth  + Math.abs(gaps.left) + gaps.right  + strokeW
    const height = svgHeight + Math.abs(gaps.top)  + gaps.bottom + strokeW

    
    // console.group()
    // console.log(props)
    // console.log(strokeW)
    // console.log(gaps)
    // console.log(drawCurve())
    // console.log("svgWidth", svgWidth )
    // console.log("width", width )
    // console.log("position.w", w )
    // console.groupEnd()
    

    return <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width={ width }
            height={ height }
            viewBox={`0 0 ${ width } ${ height }`}
            xmlSpace="preserve"
            className={ `${primitive.className} landing-primitive-svg` }
            style={{
                top:  gaps.top!  - strokeW * 2,
                left: gaps.left! - strokeW * 2,
            }}
        >
            <path
                fill={fill}
                stroke={ color }
                strokeWidth={ strokeW }
                d={ drawCurve() }
            />
        </svg>
}
export default Curve